import React, { Suspense, useState, useEffect, useRef } from "react";
import { Text, Box } from "@chakra-ui/react";

import { selectStyle } from "../Team Members/dynamic";

//importing spinner
import Spinner from "../Spinner";

//importing list
import listOfArticles from "./Articles/article-list";
import listOfBookChapters from "./Book chapters/book-chapters-list";
import listOfConference from "./Conferences/conferences-list";
import listOfPatent from "./Patent/patent-list";

const ShowList = React.lazy(() => import("./showList"));

const style = {
  padding: "0.7rem",
  outline: "0",
  textDecoration: "none",
  cursor: "pointer",
  transition: "border-bottom 0.2s ease-in",
};

const hoverStyle = {
  borderBottom: "1px solid black",
  transition: "border-bottom 0.3s ease-in",
};

export const filterStyle = {
  width: "fit-content",
  padding: "0.8rem",
  border: "1px solid #473198",
  fontSize: "16px",
  cursor: "pointer",
  borderRadius: "10px",
  transition: "background 0.3s ease-in,color 0.3s ease-in",
};

export default function Publications() {
  const [menu, setMenu] = useState("Patent");
  const [list, setList] = useState(listOfPatent);
  const [width, setWidth] = useState(window.innerWidth);
  const [year, setYear] = useState("All");

  const refContainer = useRef(null);

  //for ref
  useEffect(() => {
    refContainer.current.scrollIntoView({ behavior: "smooth" });
  }, []);

  //onclick function to change menu
  const handleClick = (e) => {
    if (e.target.innerText === "Patent") {
      setMenu("Patent");
    }
    if (e.target.innerText === "Articles") {
      setMenu("Articles");
    }
    if (e.target.innerText === "Book Chapters") {
      setMenu("Book Chapters");
    }
    if (e.target.innerText === "Conference Proceedings") {
      setMenu("Conference Proceedings");
    }
  };
  //onclick function to change year
  const handleYearClick = (e) => {
    setYear(e.target.innerText);
  };

  //onchange handler for changing menu or tab
  const handleChange = (e) => {
    setMenu(e.target.value);
  };

  useEffect(() => {
    if (menu === "Patent") setList(listOfPatent);
    if (menu === "Articles") setList(listOfArticles);
    if (menu === "Book Chapters") setList(listOfBookChapters);
    if (menu === "Conference Proceedings") setList(listOfConference);
  }, [menu]);

  //useeffect for changing width
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  }, [width]);

  return (
    <Box
      id="publications"
      background="white"
      padding="1rem"
      marginInlineStart={{ base: "0", md: "0.1rem", xl: "1rem" }}
      minHeight="100vh"
      ref={refContainer}
    >
      <Box textAlign="center">
        <Text fontSize="3xl" fontWeight={700}>
          Publications
        </Text>
      </Box>
      {width < 637 ? (
        <>
          {" "}
          <Box
            display="flex"
            flexDirection="column-reverse"
            alignItems="center"
            justifyContent="space-around"
            marginBottom="15px"
            marginTop="15px"
            gap="20px"
          >
            <Box>
              <Text
                fontSize="20px"
                borderBottom="1px solid #473198"
                padding="1rem"
              >
                {menu}
              </Text>
            </Box>
            <Box display="flex" gap="10px" alignItems="center">
              <Text fontSize="16px">Choose Option:</Text>
              <select style={selectStyle} onChange={handleChange}>
                <option
                  value="Patent"
                  selected={menu === "Patent" ? true : false}
                >
                  Patent
                </option>
                <option
                  value="Articles"
                  selected={menu === "Articles" ? true : false}
                >
                  Articles
                </option>
                <option
                  value="Book Chapters"
                  selected={menu === "Book Chapters" ? true : false}
                >
                  Book Chapters
                </option>
                <option
                  value="Conference Proceedings"
                  selected={menu === "Conference Proceedings" ? true : false}
                >
                  Conference Proceedings
                </option>
              </select>
            </Box>
          </Box>
          <Box
            display="flex"
            flexWrap="wrap"
            gap="10px"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "All" ? "#473198" : "white"}
              color={year === "All" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              All
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "2022" ? "#473198" : "white"}
              color={year === "2022" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              2022
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "2021" ? "#473198" : "white"}
              color={year === "2021" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              2021
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "2020" ? "#473198" : "white"}
              color={year === "2020" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              2020
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "2019" ? "#473198" : "white"}
              color={year === "2019" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              2019
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "Earlier" ? "#473198" : "white"}
              color={year === "Earlier" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              Earlier
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Box display="flex" justifyContent="center" marginY="30px">
            <Box
              style={style}
              onClick={handleClick}
              borderBottom={menu === "Patent" ? "1px solid #473198" : ""}
              _hover={hoverStyle}
            >
              <Text fontSize="20px">Patent</Text>
            </Box>
            <Box
              style={style}
              onClick={handleClick}
              borderBottom={menu === "Articles" ? "1px solid #473198" : ""}
              _hover={hoverStyle}
            >
              <Text fontSize="20px">Articles</Text>
            </Box>
            <Box
              style={style}
              onClick={handleClick}
              borderBottom={menu === "Book Chapters" ? "1px solid #473198" : ""}
              _hover={hoverStyle}
            >
              <Text fontSize="20px">Book Chapters</Text>
            </Box>
            <Box
              style={style}
              onClick={handleClick}
              borderBottom={
                menu === "Conference Proceedings" ? "1px solid #473198" : ""
              }
              _hover={hoverStyle}
            >
              <Text fontSize="20px">Conference Proceedings</Text>
            </Box>
          </Box>
          <Box
            display="flex"
            flexWrap="wrap"
            gap="10px"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "All" ? "#473198" : "white"}
              color={year === "All" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              All
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "2022" ? "#473198" : "white"}
              color={year === "2022" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              2022
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "2021" ? "#473198" : "white"}
              color={year === "2021" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              2021
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "2020" ? "#473198" : "white"}
              color={year === "2020" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              2020
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "2019" ? "#473198" : "white"}
              color={year === "2019" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              2019
            </Box>
            <Box
              style={filterStyle}
              _hover={{ background: "#473198", color: "white" }}
              background={year === "Earlier" ? "#473198" : "white"}
              color={year === "Earlier" ? "white" : "black"}
              onClick={(e) => handleYearClick(e)}
            >
              Earlier
            </Box>
          </Box>
        </>
      )}

      <Box padding="1rem" marginLeft="20px">
        <Suspense fallback={<Spinner />}>
          <ShowList list={list} year={year} />
        </Suspense>
      </Box>
    </Box>
  );
}
